let fetchDataRunSeq = 0;
let activeFetchDataRuns = 0;
let bodyApiCallSeq = 0;
let activeBodyApiCalls = 0;

export const describeMailboxItem = (item, { propsItem } = {}) => {
  try {
    const mailboxItem = Office.context.mailbox?.item;
    const subject =
      typeof item?.subject === "string" ? item.subject : item?.subject ? "[async subject]" : null;

    return {
      internetMessageId: item?.internetMessageId ?? null,
      inReplyTo: item?.inReplyTo ?? null,
      conversationId: item?.conversationId ?? null,
      itemType: item?.itemType ?? null,
      subject,
      from: item?.from?.emailAddress ?? item?.from?.displayName ?? null,
      itemRef: item ?? null,
      propsItemSameRef: propsItem != null ? Object.is(item, propsItem) : null,
      mailboxItemSameRefAsArg: item != null ? Object.is(mailboxItem, item) : null,
      mailboxItemSameRefAsProps: propsItem != null ? Object.is(mailboxItem, propsItem) : null,
    };
  } catch (error) {
    return { error: String(error) };
  }
};

export const beginFetchDataRun = (context = {}) => {
  const runId = ++fetchDataRunSeq;
  activeFetchDataRuns += 1;
  const startedAt = performance.now();

  console.log("[fetchData] RUN START", {
    runId,
    activeFetchDataRuns,
    ...context,
  });

  return {
    runId,
    startedAt,
    log(phase, extra = {}) {
      console.log(`[fetchData] RUN #${runId} ${phase}`, {
        elapsedMs: Math.round(performance.now() - startedAt),
        activeFetchDataRuns,
        ...extra,
      });
    },
    end(status, extra = {}) {
      activeFetchDataRuns = Math.max(0, activeFetchDataRuns - 1);
      console.log(`[fetchData] RUN END #${runId} ${status}`, {
        elapsedMs: Math.round(performance.now() - startedAt),
        activeFetchDataRuns,
        ...extra,
      });
    },
  };
};

export const logBodyApiCall = (event, caller, details = {}) => {
  if (event === "start") {
    const callId = ++bodyApiCallSeq;
    activeBodyApiCalls += 1;
    console.log(`[outlookUtils] body API #${callId} START`, {
      caller,
      activeBodyApiCalls,
      ...details,
    });
    return { callId, startedAt: performance.now() };
  }

  const { callId, startedAt, error } = details;
  activeBodyApiCalls = Math.max(0, activeBodyApiCalls - 1);
  console.log(`[outlookUtils] body API #${callId} ${event}`, {
    caller,
    elapsedMs: startedAt != null ? Math.round(performance.now() - startedAt) : null,
    activeBodyApiCalls,
    error: error ? String(error?.message || error) : undefined,
    ...details,
  });
};
